export default __webpack_public_path__ + "static/media/logofull.230255c6.svg";